import apiClient from "./index.js";

const relative_path = "configs";

export default {
   
    obtenerPasarelaPagoActiva() {
      return apiClient.get(relative_path + "/obtener-pasarela-pago-activa");
    },
}